// Tribu banner images
import padelBarcelona from './padel-barcelona.jpg';
import futbolMedellin from './futbol-medellin.jpg';
import yogaMadrid from './yoga-madrid.jpg';
import volleyballLima from './volleyball-lima.jpg';
import boxeoValencia from './boxeo-valencia.jpg';
import natacionBarcelona from './natacion-barcelona.jpg';
import ciclismoBogota from './ciclismo-bogota.jpg';
import futbolBuenosAires from './futbol-buenos-aires.jpg';
import yogaSantiago from './yoga-santiago.jpg';
import surfLima from './surf-lima.jpg';
import crossfitCiudadDeMexico from './crossfit-ciudad-de-mexico.jpg';
import futbolMadrid from './futbol-madrid.jpg';
import escaladaSantiago from './escalada-santiago.jpg';
import tangoFitnessBuenosAires from './tango-fitness-buenos-aires.jpg';
import luchaLibreCiudadDeMexico from './lucha-libre-ciudad-de-mexico.jpg';
import runningBarcelona from './running-barcelona.jpg';
import ciclismoValencia from './ciclismo-valencia.jpg';
import parapenteMedellin from './parapente-medellin.jpg';
import gimnasioSevilla from './gimnasio-sevilla.jpg';
import artesMarcialesSevilla from './artes-marciales-sevilla.jpg';
import runningBogota from './running-bogota.jpg';
import crossfitMadrid from './crossfit-madrid.jpg';

// Additional specific tribu images
import boxeoValenciaGimnasioCombate from './boxeo-valencia-gimnasio-combate.jpg';
import ciclismoBogotaGrupoCiclistas from './ciclismo-bogota-grupo-ciclistas.jpg';
import crossfitMadridEntrenamientoFuncional from './crossfit-madrid-entrenamiento-funcional.jpg';
import futbolBuenosAiresEquipoAmateur from './futbol-buenos-aires-equipo-amateur.jpg';
import futbolMadridEquipoAficionados from './futbol-madrid-equipo-aficionados.jpg';
import natacionBarcelonaClubNadadores from './natacion-barcelona-club-nadadores.jpg';
import padelBarcelonaComunidadJugadores from './padel-barcelona-comunidad-jugadores.jpg';
import runningBarcelonaGrupoCorredores from './running-barcelona-grupo-corredores.jpg';
import surfLimaComunidadSurfistas from './surf-lima-comunidad-surfistas.jpg';
import yogaMadridClasesMeditacion from './yoga-madrid-clases-meditacion.jpg';

// Generic fallback images
import fitnessGeneric from './fitness-generic.jpg';
import deportesGeneric from './deportes-generic.jpg';
import aventuraGeneric from './aventura-generic.jpg';
import acuaticosGeneric from './acuaticos-generic.jpg';
import baileGeneric from './baile-generic.jpg';

export const tribuBanners: Record<string, string> = {
  'padel-barcelona': padelBarcelona,
  'futbol-medellin': futbolMedellin,
  'yoga-madrid': yogaMadrid,
  'volleyball-lima': volleyballLima,
  'boxeo-valencia': boxeoValencia,
  'natacion-barcelona': natacionBarcelona,
  'ciclismo-bogota': ciclismoBogota,
  'futbol-buenos-aires': futbolBuenosAires,
  'yoga-santiago': yogaSantiago,
  'surf-lima': surfLima,
  'crossfit-ciudad-de-mexico': crossfitCiudadDeMexico,
  'futbol-madrid': futbolMadrid,
  'escalada-santiago': escaladaSantiago,
  'tango-fitness-buenos-aires': tangoFitnessBuenosAires,
  'lucha-libre-ciudad-de-mexico': luchaLibreCiudadDeMexico,
  'running-barcelona': runningBarcelona,
  'ciclismo-valencia': ciclismoValencia,
  'parapente-medellin': parapenteMedellin,
  'gimnasio-sevilla': gimnasioSevilla,
  'artes-marciales-sevilla': artesMarcialesSevilla,
  'running-bogota': runningBogota,
  'crossfit-madrid': crossfitMadrid,
  // Additional specific slugs
  'boxeo-valencia-gimnasio-combate': boxeoValenciaGimnasioCombate,
  'ciclismo-bogota-grupo-ciclistas': ciclismoBogotaGrupoCiclistas,
  'crossfit-madrid-entrenamiento-funcional': crossfitMadridEntrenamientoFuncional,
  'futbol-buenos-aires-equipo-amateur': futbolBuenosAiresEquipoAmateur,
  'futbol-madrid-equipo-aficionados': futbolMadridEquipoAficionados,
  'natacion-barcelona-club-nadadores': natacionBarcelonaClubNadadores,
  'padel-barcelona-comunidad-jugadores': padelBarcelonaComunidadJugadores,
  'running-barcelona-grupo-corredores': runningBarcelonaGrupoCorredores,
  'surf-lima-comunidad-surfistas': surfLimaComunidadSurfistas,
  'yoga-madrid-clases-meditacion': yogaMadridClasesMeditacion,
};

export const genericImages: Record<string, string> = {
  'fitness': fitnessGeneric,
  'deportes': deportesGeneric,
  'aventura': aventuraGeneric,
  'acuaticos': acuaticosGeneric,
  'baile': baileGeneric,
};
